import { v4 as uuidv4 } from 'uuid'
import { EmailCaptureRequest, GrowthService } from '@mc/api'
import { identify, track, Product } from '@mc/track-event'

export interface EmailCaptureParams {
  email: string
  event_name?: string
  page_source?: string
  campaign?: string
  location?: string
  content_type?: string
  slug?: string
  type?: string
  platform?: string
  category?: string
  page_type?: string
  class_type?: string
  coming_soon_slug?: string
  marketing_consent?: boolean
  product?: string
  event_id?: string
  customProperties?: Record<string, unknown>
}

export const trackEmailCaptured = async (payload: {
  event: string
  properties: EmailCaptureParams
  integrations?: Record<string, boolean>
}) => {
  const { properties, event, integrations = {} } = payload

  // Generate a unique event ID for deduplication
  const eventId = uuidv4()

  // If cookies are enabled now: sends an identify immediately
  // If cookies are disabled now: queues an identify that will send if cookies are enabled later
  identify(null, {
    email: properties?.email,
    integrations: { Iterable: true, ...integrations },
  })

  // Send only essential data to backend for Iterable tracking
  const essentialEmailCaptureParams: EmailCaptureRequest = {
    email: properties?.email,
    eventName: event,
    campaign: properties?.campaign,
    marketingConsent: properties?.marketing_consent ?? true,
    product: Product.CORE,
    eventId,
  }

  // Track essential data on backend via Iterable
  try {
    await GrowthService.createEmailCapture({
      requestBody: essentialEmailCaptureParams,
    })
  } catch {
    // Fail silently - we still want to try Segment tracking below
  }

  // Track additional data via Segment from frontend with the same event name and ID
  track(
    event,
    {
      email: properties?.email,
      event_name: event,
      page_source: properties?.page_source,
      campaign: properties?.campaign,
      location: properties?.location,
      content_type: properties?.content_type,
      slug: properties?.slug,
      type: properties?.type,
      category: properties?.category,
      marketing_consent: properties?.marketing_consent ?? true,
      product: Product.CORE,
      event_id: eventId,
      ...properties?.customProperties,
    },
    {
      integrations: {
        All: false,
        Iterable: true,
        Amplitude: true,
        ...integrations,
      },
      messageId: eventId, // messageId will deduplicate the event in Iterable
    },
  )
}
